<template>
  <SmartDrawer
    @close="closeDetails"
    :show="hasID">
    <template v-slot:header>
      <template v-if="openedInfo">
        <SmartTitle
          class="text-brand-secondary"
          weight="medium">
          {{ quizz.name }}
        </SmartTitle>
        {{ quizz.description }}
      </template>

      <SmartRow v-else>
        <SmartSkeletonLoading
          class="lg:col-6"
          :height="3"
        />
      </SmartRow>
    </template>

    <slot :openedInfo="openedInfo" />
  </SmartDrawer>
</template>

<script>
// @flow
import { mapActions } from 'vuex';
import { capitalize } from 'assets/filters';

const formMemo = {};

export default {
  filters: { capitalize },
  data() {
    return {
      openedInfo: null
    };
  },
  computed: {
    type() {
      return this.$route.params.type;
    },
    id() {
      return this.$route.params.id || -1;
    },
    hasID() {
      return this.id !== -1;
    },
    quizz() {
      return this.openedInfo.quizz;
    }
  },
  watch: {
    id() {
      this.setInformations();
    }
  },
  created() {
    this.setInformations();
  },
  methods: {
    ...mapActions({
      fetchQuizzByID: 'form/fetchQuizzByID'
    }),
    setOpenedAndMemoize([quizz, availableFor]): Function {
      formMemo[this.id] = { quizz, availableFor };
      this.openedInfo = formMemo[this.id];
    },
    setInformations() {
      if (!this.hasID) return;

      if (formMemo[this.id]) {
        this.openedInfo = formMemo[this.id];
      } else {
        this.openedInfo = null;
        this.fetchQuizzByID(this.id).then(this.setOpenedAndMemoize);
      }
    },
    closeDetails() {
      this.$router.push({
        name: 'FormList',
        params: {
          type: this.type
        }
      });
    }
  }
};
</script>
